import React, { PropsWithChildren, useLayoutEffect, useRef } from 'react';
import { createBrowserInspector } from '@statelyai/inspect';
import { useNextTick } from 'src/hooks/useNextTick';

let globalInspector: ReturnType<typeof createBrowserInspector> | null = null;

export function getGlobalInspector() {
    return globalInspector;
}

export function Inspect(props: { styles?: Partial<CSSRuleList>; display?: 'iframe' | 'new-window' }) {
    const { styles, display = 'iframe' } = props;
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const nextStyles = {
        width: '100%',
        height: '60vh',
        marginTop: '50px',
        ...styles,
    };
    useLayoutEffect(() => {
        const iframe = display === 'iframe' ? iframeRef.current : undefined;
        const inspector = createBrowserInspector({
            url: 'https://stately.ai/inspector',
            iframe: iframe ?? undefined,
            autoStart: true,
        });
        globalInspector = inspector;
        return () => {
            globalInspector = null;
        };
    }, [display]);
    return <iframe ref={iframeRef} data-xstate style={nextStyles} />;
}

Inspect.Inner = function Inner(props: PropsWithChildren<any>) {
    const ready = useNextTick();
    if (!ready) return null;
    return props.children;
};
